import { reimbursementsHandlers } from "./reimbursements";
import { routerHandlers } from "./router";
import { settingsHandlers } from "./settings";
import { teamHandlers } from "./team";
import { techUiHandlers } from "./tech-ui";

// Settings handlers precede the tech-ui ones so the settings `/enums/` variant
// is matched before the tech-ui shell's bare `/enums/` fall-through handler. The
// team handlers sit in the same band: their `*/companies/` and `*/companies/v2/`
// lists must be matched before tech-ui's `*/companies/v2/:companyId` shell lookup.
// The reimbursements handlers own a disjoint path prefix
// (`*/proxy/company-car-orchestrator/...`) plus `*/charge-record/v2/...`, which no
// other handler claims, so their position in the band is not load-bearing — but
// the ORDER WITHIN that file is (see its own note on `non-linked-items`).
const handlers = [
  ...routerHandlers,
  ...settingsHandlers,
  ...reimbursementsHandlers,
  ...teamHandlers,
  ...techUiHandlers,
];

export { handlers };
